import type { ReactNode } from 'react';

import { useSessionStore } from '@/entities/session';
import { AuthFailed, useSessionBootstrap } from '@/features/auth-telegram';
import { Spinner } from '@/shared/ui';

interface RequireAuthProps {
  children: ReactNode;
}

/**
 * Гард авторизации.
 *
 * Редиректа на «страницу входа» нет намеренно: логин в мини-аппе неинтерактивный —
 * initData либо есть, либо приложение открыто не из Telegram. Поэтому здесь
 * три состояния: ждём, пустили, показали ошибку с кнопкой «ещё раз».
 */
export function RequireAuth({ children }: RequireAuthProps) {
  const { status, error, retry } = useSessionBootstrap();
  const user = useSessionStore((state) => state.user);

  if (status === 'error') {
    return <AuthFailed message={error} onRetry={retry} />;
  }

  if (status !== 'authenticated' || !user) {
    return <Spinner label="Входим через Telegram" />;
  }

  return children;
}
